import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import classNames from "classnames";
import { Spinner } from "./Spinner.js";
import { Aether } from "./Aether/Aether.js";
import { useComponentClassName } from "../auxiliary/useComponentClassName.js";
import { toEnumViewClass } from "../utils/toEnumViewClass.js";
const ContainerSpinner = memo(({ size }) => /* @__PURE__ */ jsx(Aether, { className: classNames(useComponentClassName("containerSpinner"), toEnumViewClass(size)), children: /* @__PURE__ */ jsx(Spinner, {}) }));
ContainerSpinner.displayName = "ContainerSpinner";
export {
  ContainerSpinner
};
//# sourceMappingURL=ContainerSpinner.js.map
